import React, { useState } from "react";
import { IExpenseRecord } from "../../../lib/types";
import { format } from "date-fns";
import { formatToEuro } from "../../../lib/utils";
import ExpenseCategoryIcon from "./ExpenseCategoryIcon";
import EditExpense from "./EditExpense";

interface ExpenseItemProps {
    expense: IExpenseRecord;
    editable?: boolean;
    reload?: () => void;
}
export default function ExpenseItem({ expense, editable = false, reload }: ExpenseItemProps) {
    const [editing, setEditing] = useState(false);
    return (
        <React.Fragment>
            <button onClick={() => setEditing(editable)} className={`flex items-center justify-between rounded-lg border px-4 py-2 text-left ${editable ? "cursor-pointer" : "cursor-default"}`}>
                <div className="flex items-center gap-4">
                    <ExpenseCategoryIcon category={expense.expand.type} />
                    <div className="flex flex-col leading-5">
                        <h2 className="font-bold">
                            {expense.name} <span className="text-sm font-medium">{expense.amount > 1 ? `(${expense.amount}x)` : ""}</span>
                        </h2>
                        <h3 className="text-sm text-slate-500">{format(new Date(expense.date), "d MMMM Y")}</h3>
                    </div>
                </div>
                <div>
                    <h4 className="font-bold">{formatToEuro(expense.price * expense.amount * (expense.income ? 1 : -1))}</h4>
                </div>
            </button>
            <EditExpense open={editing} setOpen={(x) => setEditing(x)} expense={expense} reload={reload} />
        </React.Fragment>
    );
}
